import "./TranscriptPhrase.less";

import { GuxIcon } from "genesys-spark-components-react";
import { InnerI18nTranslations } from "@purecloud/ts-i18n";

function TranscriptWord({
    word,
    recognizedEntityTypes,
}: {
    word: string;
    recognizedEntityTypes: InnerI18nTranslations<
        {
            [keys: string]: string;
        },
        string
    >;
}) {
    const isRedacted = word.startsWith("[") && word.endsWith("]");
    const entityType = isRedacted ? word.slice(1, word.indexOf("]")) : "";

    const placeholderText =
        entityType in recognizedEntityTypes
            ? recognizedEntityTypes[entityType]
            : entityType;

    return (
        <span className="TranscriptWord">
            {isRedacted ? (
                <span className="redactedWord">
                    <GuxIcon iconName="shield-lock" decorative={true} />
                    {placeholderText}
                </span>
            ) : (
                <span> {word} </span>
            )}
        </span>
    );
}

export function TranscriptPhrase({
    transcriptPhrase,
    recognizedEntityTypes,
}: {
    transcriptPhrase: string | undefined;
    recognizedEntityTypes: InnerI18nTranslations<
        {
            [keys: string]: string;
        },
        string
    >;
}) {
    const transcriptWords = transcriptPhrase ? transcriptPhrase.split(" ") : [];

    return (
        <span className="TranscriptPhrase">
            {transcriptWords
                .map<React.ReactNode>((transcriptWord) => {
                    return (
                        <TranscriptWord
                            word={transcriptWord}
                            recognizedEntityTypes={recognizedEntityTypes}
                        />
                    );
                })
                .reduce((prev, curr) => [prev, " ", curr], "")}
        </span>
    );
}
